<template>
  <div
    v-if="isLoad"
    id="lb-sort"
    class="filter-modal"
    tabindex="-1"
    :class="{ active: advancedPopup }"
  >
    <div class="modal-content">
      <div class="modal-body">
        <div class="sort-block">
          <h5>PRICE</h5>
          <div class="sort-condition nowrap">
            <input
              type="hidden"
              class="range-slider"
              :value="condition.PriceLow + ',' + rangeHeight"
            />
          </div>
        </div>
        <div class="sort-block">
          <h5>SIZE</h5>
          <div class="sort-condition size-opts">
            <div v-for="size in condition.Sizes" :key="size.Key" class="size-block">
              <div
                :class="toggleSize(size.Value)"
                class="item-size"
                @click.prevent="addSize(size.Value)"
              >
                {{ size.Key }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a class="btn btn-reset" href="#" @click.prevent="clearCondition">RESET</a>
        <a class="btn btn-confirm" href="#" @click.prevent="goResult">APPLY</a>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import jRange from 'jquery-range';
import { ref, watch, nextTick } from 'vue';

export default {
  props: {
    condition: {
      type: Object,
      required: true,
    },
    advancedPopup: {
      type: Boolean,
      required: true,
    },
    isLoad: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedSizes: [],
      selectedPriceRange: [],
      sortCurrency: '',
      rangeHeight: 1000,
    };
  },
  watch: {
    isLoad(val) {
      // eslint-disable-next-line no-underscore-dangle
      /**
       * @description 刻度隨單位不同
       */
      const _this = this;
      _this.sortCurrency = this.condition.CurrentCurrency;
      let step = 100;
      switch (_this.sortCurrency) {
        case 'TWD':
          step = 100;
          if (_this.condition.PriceHigh % 1000 !== 0) {
            _this.rangeHeight = Math.ceil(_this.condition.PriceHigh / 100) * 100;
          }
          break;
        case 'USD':
          step = 10;
          if (_this.condition.PriceHigh % 10 !== 0) {
            _this.rangeHeight = Math.ceil(_this.condition.PriceHigh / 10) * 10;
          }
          break;
        default:
          step = 100;
          break;
      }

      if (val) {
        this.$nextTick(() => {
          $('.range-slider').jRange({
            from: _this.condition.PriceLow,
            to: _this.rangeHeight,
            step,
            format: '%s',
            width: 250,
            showLabels: true,
            isRange: true,
            theme: 'theme-black',
          });
          this.getInitArgs();
        });
      }
    },
  },
  methods: {
    checkAdvanced() {
      const hasLowPointer = document.querySelector('.pointer-label.low');
      const hasHighPointer = document.querySelector('.pointer-label.high');
      const scale = document.querySelector('.slider-container .scale');
      const addClass = `currency-${this.sortCurrency}`;

      if (hasLowPointer && hasHighPointer && scale) {
        hasLowPointer.classList.add(addClass);
        hasHighPointer.classList.add(addClass);
        scale.classList.add(addClass);
      } else {
        setTimeout(this.checkAdvanced, 100);
      }
    },
    getInitArgs() {
      const initSize = this.getTargetArgValue('S=').split(',');
      if (initSize[0].length !== 0) this.selectedSizes = initSize;
      if (this.getTargetArgValue('PL') !== '') {
        $('.range-slider').jRange(
          'setValue',
          `${this.getTargetArgValue('PL')},${this.getTargetArgValue('PH')}`,
        );
      }
      this.checkAdvanced();
    },
    getTargetArgValue(arg) {
      let targetArg = '';
      if (window.location.search.length !== 0 && window.location.search.indexOf(arg) !== -1) {
        const args = window.location.toString().split('?')[1].split('&');
        args.forEach((element, index) => {
          if (element.indexOf(arg) !== -1) {
            targetArg = element;
          }
        });
      }
      return targetArg.length !== 0
        ? targetArg.substring(targetArg.indexOf('=') + 1, targetArg.length)
        : '';
    },
    clearCondition() {
      this.selectedSizes = [];
      $('.range-slider').jRange(
        'setValue',
        `${this.condition.PriceLow},${this.condition.PriceHigh}`,
      );
    },
    addSize(size) {
      const index = this.selectedSizes.findIndex((e) => {
        return e === size.toString();
      });

      if (index >= 0) {
        this.selectedSizes.splice(index, 1);
      } else {
        this.selectedSizes.push(size.toString());
      }
    },
    toggleSize(size) {
      const isSelected = this.selectedSizes.includes(size.toString());
      return {
        active: isSelected,
        '': !isSelected,
      };
    },
    getPriceRangeArg() {
      const pl = $('.pointer-label.low').text();
      const ph = $('.pointer-label.high').text();
      return $('.range-slider').val() !== `${this.condition.PriceHigh},${this.condition.PriceLow}`
        ? `PL=${pl}&PH=${ph}`
        : '';
    },
    getSizeArg() {
      return this.selectedSizes.length !== 0 ? `S=${this.selectedSizes.toString()}` : '';
    },
    goResult() {
      let argsString = '';

      if (window.location.search.length !== 0) {
        const args = window.location.toString().split('?')[1].split('&');
        let i = 0;

        while (i < args.length) {
          if (args[i].indexOf('PH') !== -1) {
            args.splice(i, 1);
          } else if (args[i].indexOf('PL') !== -1) {
            args.splice(i, 1);
          } else if (args[i].indexOf('S=') !== -1) {
            args.splice(i, 1);
          } else if (args[i].indexOf('P=') !== -1) {
            args.splice(i, 1);
          } else {
            i += 1;
          }
        }
        if (args.length !== 0) {
          if (
            this.selectedSizes.length !== 0 ||
            $('.range-slider').val() !== `${this.condition.PriceHigh},${this.condition.PriceLow}`
          ) {
            argsString = `${args.join('&')}&`;
          } else if (args.length !== 0) {
            argsString = `${args.join('&')}`;
          }
        }
      }
      if (
        this.selectedSizes.length !== 0 ||
        $('.range-slider').val() !== `${this.condition.PriceHigh},${this.condition.PriceLow}`
      ) {
        window.location.href = `${
          window.location.pathname
        }?${argsString}${this.getPriceRangeArg()}${
          this.getPriceRangeArg().length !== 0 && this.getSizeArg().length !== 0 ? '&' : ''
        }${this.getSizeArg()}`;
      } else if (argsString.length === 0) {
        window.location.href = window.location.pathname;
      } else {
        window.location.href = `${window.location.pathname}?${argsString}`;
      }
    },
  },
};
</script>
